import { render, staticRenderFns } from "./addToPositionModal.vue?vue&type=template&id=ae74ce68&scoped=true&"
import script from "./addToPositionModal.vue?vue&type=script&lang=js&"
export * from "./addToPositionModal.vue?vue&type=script&lang=js&"
import style0 from "./addToPositionModal.vue?vue&type=style&index=0&id=ae74ce68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae74ce68",
  null
  
)

export default component.exports